import { Api } from "../../../../config/Api";
import { statusAndResponse } from "../../../../util/requestHandler";

export const getRingCentralMessages = async (queryParams) => {
  const onSuccess = (data) => {
    return data.data;
  };

  return statusAndResponse(
    Api.get(`/api/sms/v1/ringcentral/messages?${queryParams}`),
    onSuccess,
  );
};
